import type { TFunction } from 'i18next';

type Metrics = {
  device: string;
  temperature: string;
  humidity: string;
  humidityUnits: string;
  soilMoisture: string;
  soilTemperature: string;
  dewPoint: string;
  dewfallDuration: string;
  dewfallIntensity: string;
  gdd: string;
  plantNdvi: string;
  ndvi: string;
  soilNdvi: string;
  leafNdvi: string;
  leafArea: string;
  photoNdvi: string;
};

export const getMetricsLabels = (t: TFunction): Metrics => ({
  device: t('metrics.device'),
  temperature: t('metrics.temperature'),
  humidity: t('metrics.humidity'),
  humidityUnits: `${t('metrics.humidity')} (%)`,
  soilMoisture: t('metrics.soilMoisture'),
  soilTemperature: t('metrics.soilTemperature'),
  dewPoint: t('metrics.dewPoint'),
  dewfallDuration: t('metrics.dewfallDuration'),
  dewfallIntensity: t('metrics.dewfallIntensity'),
  gdd: 'GDD',
  plantNdvi: t('metrics.plantNdvi'),
  ndvi: 'NDVI',
  soilNdvi: t('metrics.soilNdvi'),
  leafNdvi: t('metrics.leafNdvi'),
  leafArea: t('metrics.leafArea'),
  photoNdvi: t('metrics.photoNdvi'),
});
